/* istanbul ignore file */
/**
 * Toolbar and breadcrumb component theme configurations.
 */

export const toolbarComponentConfig = {
  toolbar: {
    root: {
      background: '{content.background}',
      borderColor: '{content.border.color}',
      borderRadius: '0',
      color: '{content.color}',
      gap: '0.5rem',
      padding: '0.75rem',
    },
  },
};

export const breadcrumbComponentConfig = {
  breadcrumb: {
    root: {
      padding: '16px',
      background: '{surface.0}',
      gap: '8px',
      transitionDuration: '{transition.duration}',
    },
    item: {
      color: '{surface.900}',
      hoverColor: '{primary.600}',
      borderRadius: '{border.radius.none}',
      gap: '8px',
      icon: {
        color: '{surface.800}',
        hoverColor: '{surface.800}',
      },
      focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: '{focus.ring.shadow}',
      },
    },
    separator: {
      color: '{surface.400}',
    },
  },
};
